import { ErrorHandler, LOCALE_ID, NgModule, inject, provideAppInitializer } from '@angular/core';
import {registerLocaleData} from '@angular/common';
import {TranslateLoader, provideTranslateService} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {BrowserModule} from '@angular/platform-browser';
import {HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import * as Sentry from '@sentry/angular';
import {Router} from '@angular/router';
import localeDE from '@angular/common/locales/de';
import {StepService} from '../services/step.service';
import {AdvisorSharedModule} from '../advisor.shared.module';
import {PortalService} from '../services/portal.service';
import {MatCheckboxModule} from "@angular/material/checkbox";
import {SafeHtmlPipe} from "../pipe/SafeHtmlPipe";
import {WarmwassercheckComponent} from "./warmwassercheck.component";
import {WarmwassercheckRoutingModule} from "./warmwassercheck-routing.module";
import {MatButtonModule} from "@angular/material/button";
import {EingabeStartComponent} from "./eingabe/eingabe.start.component";
import {EingabeStepComponent} from "./eingabe/eingabe.step.component";
import {ErgebnisAnalyseComponent} from "./ergebnis/ergebnis.analyse.component";
import {EingabeAusstiegComponent} from "./eingabe/eingabe.ausstieg.component";
import {ErgebnisComponent} from "./ergebnis/ergebnis.component";
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from "@angular/material/expansion";
import {ErgebnisEmpfehlungenComponent} from "./ergebnis/ergebnis.empfehlungen.component";
import {EingabeShowerDataComponent} from "./eingabe/eingabe.shower-data.component";

// global definition of language prefix
declare let advisorTranslationPrefix;

// AoT requires an exported function for factories
export function HttpLoaderFactory() {
  const http = inject(HttpClient);
  return {
    getTranslation: (lang: string) => http.get<object>(
      (typeof advisorTranslationPrefix !== 'undefined' ? advisorTranslationPrefix : 'translations/' + PortalService.defaultPortal + '/warmwassercheck/') + lang + '.json'
    )
  };
}

// always load de locales for number formats
registerLocaleData(localeDE, 'de');

/**
 * returns the users locale from the browser
 */
function getBrowsersLocale() {
  /* tslint:disable:no-string-literal */
  if (navigator['browserLanguage']) {
    return navigator['browserLanguage'];
  }
  else if (navigator.language) {
    return navigator.language;
  }
  /* tslint:enable:no-string-literal */
}

@NgModule({
  declarations: [
    EingabeStartComponent,
    EingabeStepComponent,
    SafeHtmlPipe,
    WarmwassercheckComponent,
    ErgebnisAnalyseComponent,
    EingabeAusstiegComponent,
    ErgebnisComponent,
    ErgebnisEmpfehlungenComponent,
    EingabeShowerDataComponent
  ],
  bootstrap: [
    WarmwassercheckComponent
  ],
  imports: [
    BrowserModule,
    WarmwassercheckRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    AdvisorSharedModule,
    MatButtonModule,
    MatCheckboxModule,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'de-DE'},
    {provide: LOCALE_ID, useValue: getBrowsersLocale()},
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
        dialogOptions: {
          user: {
            name: 'dummy',
            email: 'dummy@co2online.de'
          }
        }
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      const initializerFn = () => {
        inject(Sentry.TraceService)
      };
        return initializerFn();
      }),
    StepService,
        provideTranslateService({loader: {provide: TranslateLoader, useFactory: HttpLoaderFactory}}),
        provideHttpClient(withInterceptorsFromDi())
  ]
})
export class WarmwassercheckModule {
}
